import { LodgeGridConf } from '../models/lodge.interface';

export function getGridStyles(grid_conf: LodgeGridConf) {
  return {
    'grid-row': `${grid_conf?.row?.pos} / span ${grid_conf?.row?.span}`,
    'grid-column': `${grid_conf?.column?.pos} / span ${grid_conf?.column?.span}`,
    'background-color': grid_conf?.bgcolor,
    color: grid_conf?.color,
  };
}
